var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16 29.3333C22.3844 29.3333 27.56 24.1577 27.56 17.7733C27.56 11.3889 22.3844 6.21333 16 6.21333C9.61559 6.21333 4.44 11.3889 4.44 17.7733C4.44 24.1577 9.61559 29.3333 16 29.3333Z",
    fill: "#277BA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.3333C15.4533 18.3333 15 17.88 15 17.3333V10.6667C15 10.12 15.4533 9.66667 16 9.66667C16.5467 9.66667 17 10.12 17 10.6667V17.3333C17 17.88 16.5467 18.3333 16 18.3333Z",
    fill: "#277BA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8533 4.6H12.1467C11.6133 4.6 11.1867 4.17333 11.1867 3.64C11.1867 3.10667 11.6133 2.66667 12.1467 2.66667H19.8533C20.3867 2.66667 20.8133 3.09333 20.8133 3.62667C20.8133 4.16 20.3867 4.6 19.8533 4.6Z",
    fill: "#277BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4d677b6b10f317d7518f65ec60e402f7.svg";
export { ForwardRef as ReactComponent };